/**
 * A documentacao do plugin encontra-se na url abaixo
 * Url: http://kamranahmed.info/toast
 */
(function () {
    const notiticacao = document.getElementById('notificacao');
    if(notiticacao) {
        let notCor    = notiticacao.getAttribute('data-not-cor');
        let notTitulo = notiticacao.getAttribute('data-not-titulo');
        let notIcone  = notiticacao.getAttribute('data-not-icone');
        let notTexto  = notiticacao.innerText;

        $.toast({
            heading     : notTitulo,
            text        : notTexto,
            position    : 'top-right',
            loaderBg    : notCor,
            icon        : notIcone,
            hideAfter   : 8000,
            stack       : 6
        });
    }
})();
